import { Controller } from "@hotwired/stimulus"
import IMask from "imask"

export default class extends Controller {
  connect() {
    IMask(this.element, {
      mask: this.element.dataset.mask
    })
  }
}
